import { render, staticRenderFns } from "./ProfileTooltip.vue?vue&type=template&id=036062c0&scoped=true&"
import script from "./ProfileTooltip.vue?vue&type=script&lang=js&"
export * from "./ProfileTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTooltip.vue?vue&type=style&index=0&id=036062c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036062c0",
  null
  
)

/* custom blocks */
import block0 from "./ProfileTooltip.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports